import { useTranslation } from "react-i18next"
import { publicAssetUrl } from "@/lib/publicAssetUrl"

/** Высота ряда логотипов партнёров в хедере */
export const navbarPartnerRowMinHeight = "min-h-[30px] sm:min-h-[34px]"
/** Кнопки-иконки в хедере (войти, выход, уведомления) — тот же габарит, что у ряда партнёров */
export const navbarHeaderIconButtonSize = "h-[30px] w-[30px] sm:h-[34px] sm:w-[34px]"
export const navbarHeaderIconSize = "text-lg"

export type NavbarPartnersProps = {
  onDarkBg: boolean
  /** Узкий хедер (главная): компактные логотипы, без наезда на кнопки справа */
  compact?: boolean
}

export const NavbarPartners = ({ onDarkBg, compact = false }: NavbarPartnersProps) => {
  const { t } = useTranslation()
  const leninkaArtSrc = onDarkBg
    ? publicAssetUrl("images/partners/leninkaart.svg")
    : publicAssetUrl("images/partners/leninkaart-black.svg")

  return (
    <div
      className={`flex min-w-0 ${navbarPartnerRowMinHeight} justify-start border-l pl-2 sm:pl-3 ml-0.5 ${
        compact ? "sm:flex-1 sm:min-w-0" : ""
      } ${onDarkBg ? "border-white/35" : "border-gray-200"}`}
    >
      <div
        className={`flex items-center justify-center min-w-0 ${
          compact ? "gap-1 sm:gap-1.5 sm:overflow-hidden md:gap-2" : "gap-1.5 sm:gap-2.5 md:gap-3"
        }`}
        role="group"
        aria-label={t("nav.partnersGroup")}
      >
        <img
          src={publicAssetUrl("images/partners/aila.png")}
          alt={t("nav.partnerAilaAlt")}
          className={
            compact
              ? "h-4 w-auto max-w-[2.25rem] sm:h-5 sm:max-w-[2.75rem] md:h-6 md:max-w-[3.25rem] object-contain object-center transition-opacity duration-300"
              : "h-5 w-auto max-w-[3.25rem] sm:h-6 sm:max-w-[4rem] md:h-7 md:max-w-[4.75rem] lg:h-8 lg:max-w-[5.5rem] object-contain object-center transition-opacity duration-300"
          }
          width={80}
          height={28}
          decoding="async"
        />
        <img
          src={leninkaArtSrc}
          alt={t("nav.partnerLeninkaArtAlt")}
          className={
            compact
              ? "h-4 w-auto max-w-[4rem] sm:h-5 sm:max-w-[5.5rem] md:h-6 md:max-w-[7rem] object-contain object-center transition-opacity duration-300"
              : "h-5 w-auto max-w-[6.5rem] sm:h-7 sm:max-w-[9rem] md:h-9 md:max-w-[12rem] lg:h-10 lg:max-w-[13.5rem] object-contain object-center transition-opacity duration-300"
          }
          width={248}
          height={143}
          decoding="async"
        />
      </div>
    </div>
  )
}
